<div class="title-wrapper flex">
  <h3 class="font-heading-4 ms-xsmall-r font-title-medium">{{ 'seatMap.seatTypesTitle' | finLocalization }}</h3>
  @if ((seatMap$ | async)?.isWetlease === false) {
    <fcom-icon-button
      class="flex flex--self-center ms-xsmall-r"
      id="seat-type-read-more"
      [icon]="{ name: SvgLibraryIcon.INFO }"
      [theme]="IconButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
      [size]="IconButtonSize.SMALL"
      [aria]="{ label: 'readMore' | finLocalization }"
      aria-labelledby="seat-type-read-more"
      (clickBtn)="openModal()"
    />
  }
  @if (showPersonalizedDiscountTag$ | async; as discountTagText) {
    <fcom-tag class="ms-xsmall-l" data-testid="seat-chips-discount-tag" [theme]="TagTheme.POPULAR">
      {{ discountTagText }}
    </fcom-tag>
  }
</div>
<fcom-carousel
  class="block overflow-auto"
  [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
  [nextButtonAriaLabel]="'carousel.next' | finLocalization"
>
  <div class="flex flex--nowrap">
    @for (seatType of availableSeatTypes$ | async; track seatType.seatType; let i = $index) {
      <fcom-chip
        class="ms-small-y flex--inline"
        [class.ms-xsmall-l]="i !== 0"
        [attr.data-testid]="'seat-type-' + seatType.className"
        [theme]="seatType.bundle ? ChipTheme.POPULAR : ChipTheme.LIGHT"
        [iconCategory]="IconLibrary.CUSTOM"
        (tagClicked)="handleClick(seatType)"
      >
        <div class="flex">
          <div class="seat-type-svg flex-1 ms-xsmall-y">
            <ng-container
              [ngTemplateOutlet]="seatSvg"
              [ngTemplateOutletContext]="{ icon: seatType.icon, class: 'icon-large' }"
            ></ng-container>
          </div>
          <div class="flex-1 ms-xxsmall-t ms-xxsmall-l flex--grow">
            @if (seatType.bundle) {
              <div class="font-body-2 align-left flex font-body-small">
                {{ seatType.label | finLocalization }} +
                <fcom-icon class="icon-small flex--self-center" [name]="getIconForServiceCategory(seatType.bundle)" />
              </div>
            } @else {
              <div class="font-body-2 align-left font-body-small">{{ seatType.label | finLocalization }}</div>
            }
            <div class="font-body-2 align-left font-body-small">
              @if (seatType.originalPrice) {
                <span class="strike-through ms-xxsmall-r">{{ seatType.originalPrice | finPrice }},</span>
                <span class="heather-800-text text-icon-primary">{{ seatType.price | finPrice }}</span>
              }
              @if (!seatType.originalPrice) {
                <span>{{ seatType.price | finPrice }}</span>
              }
            </div>
          </div>
        </div>
      </fcom-chip>
    }
  </div>
</fcom-carousel>

<fcom-modal
  class="seat-type-modal"
  title="{{ 'seatMap.seatTypesTitle' | finLocalization }}"
  [open]="seatTypeModalOpen"
  (close)="closeModal()"
  [buttons]="ModalButtons.CLOSE"
>
  @if (seatTypeModalOpen && availableSeatTypesInModal) {
    <div class="relative">
      @for (seatType of availableSeatTypesInModal; track $index) {
        <div class="pr-large-x pr-xxsmall-y">
          @if (seatType.article$ | async; as article) {
            <div class="seat-type-wrapper flex flex--row ps-medium-y border-bottom g-medium">
              @if (article.picture; as imageData) {
                <div data-testid="seat-map-image" class="flex-1 flex--basis0 fill image-wrapper">
                  <fin-content-image class="rounded-large" [imageData$]="imageData | finToObservable" />
                </div>
              }
              <div class="flex flex--column flex--basis0 flex-1">
                <div class="flex g-small ms-medium-b">
                  @if (seatType.icon) {
                    <div data-testid="seat-map-modal-image" class="svg-wrapper" aria-hidden="true">
                      <ng-container
                        [ngTemplateOutlet]="seatSvg"
                        [ngTemplateOutletContext]="{ icon: seatType.icon, class: 'seat-type-modal-svg' }"
                      ></ng-container>
                    </div>
                  }
                  <h2 class="font-heading-3 font-title-medium">{{ article.teaserTitle }}</h2>
                </div>
                <div
                  class="flex flex--column g-xsmall font-body-medium text-icon-primary"
                  [innerHTML]="
                    article.teaserText
                      | finAddClasses: { a: 'font-body-medium text-icon-primary', strong: 'font-body-medium-bold' }
                      | finSafe: 'html'
                  "
                ></div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
</fcom-modal>

<ng-template #seatSvg let-icon="icon" let-class="class">
  <div class="aircraft-seat-map" [ngClass]="seatMapThemeClass()">
    <svg class="block {{ class }}" viewBox="0 0 48 44" [innerHTML]="icon | finSafe: 'html'">{{ icon }}</svg>
  </div>
</ng-template>
